<template>
  <div>
    <div class="text-sm font-semibold text-secondary-800 pb-2">{{ $t("securone.documents.level") }}</div>
    <div class="border border-secondary-200 rounded divide-y divide-secondary-100">
      <!-- levels this actor may not choose are not rendered (V5: all-users is for customer users only) -->
      <label v-for="o in options" :key="o.value" class="flex items-start gap-3 px-4 py-3 cursor-pointer" :class="{ 'bg-secondary-50': value.level === o.value }">
        <input type="radio" class="form-radio mt-1" :checked="value.level === o.value" @change="setLevel(o.value)" />
        <div class="flex-1">
          <div class="text-sm text-gray-800">{{ $t("securone.scope." + o.value) }}</div>
          <div class="text-xs text-gray-500">{{ $t("securone.scope." + o.value + "_help") }}</div>
          <DepartmentPicker v-if="o.value === 'departments' && value.level === 'departments'" class="mt-2" :value="value.departmentIds" @input="setDepartments" />
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import DepartmentPicker from "./DepartmentPicker.vue";

// D-34 level radio: all users at the customer, customer users only, or
// department(s) with a picker. v-model is { level, departmentIds }. Filtering
// by level happens on read, on the server (V9).
export default {
  name: "LevelPicker",
  components: { DepartmentPicker },
  props: {
    value: { type: Object, default: () => ({ level: "departments", departmentIds: [] }) },
  },
  computed: {
    canWrite() {
      return this.$store.getters["securone/canWrite"];
    },
    options() {
      const list = [];
      if (this.canWrite.allUsersDocument) list.push({ value: "all_users" });
      if (this.canWrite.customerOnlyDocument) list.push({ value: "customer_only" });
      list.push({ value: "departments" });
      return list;
    },
  },
  methods: {
    setLevel(level) {
      this.$emit("input", { level, departmentIds: level === "departments" ? this.value.departmentIds || [] : [] });
    },
    setDepartments(departmentIds) {
      this.$emit("input", { level: "departments", departmentIds });
    },
  },
  created() {
    if (!this.options.some((o) => o.value === this.value.level)) this.setLevel("departments");
  },
};
</script>
